import axios from "axios";

export const CreateLaboratoryValueApi = async (labValue, token) => {
  try {
    const BASED_URL = process.env.REACT_APP_BASED_URL;
    const path = "/admin/laboratory-value/create?";
    const endpoint = `${BASED_URL}${path}token=${token}`;

    const response = await axios.post(endpoint, labValue);

    return response;
  } catch (error) {
    return error.response;
  }
};

export default CreateLaboratoryValueApi;
